import { render, staticRenderFns } from "./region-confirm.vue?vue&type=template&id=37506906&"
import script from "./region-confirm.vue?vue&type=script&lang=js&"
export * from "./region-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports